import { useEffect, useState } from "react";

/**
 * Single source of truth for landing-page early-bird mechanics.
 * Fetches `/api/billing/early-bird` once on mount, returns:
 *   { state, loading } where state mirrors the backend response shape:
 *   { active, quota, quota_used, quota_remaining, pricing: {monthly,yearly,lifetime: {current,regular,discount_pct,savings_usd}} }
 *
 * Falls through silently if the endpoint is unreachable — components should
 * gracefully render regular pricing when state is null.
 */
export function useEarlyBird() {
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/billing/early-bird`, { signal: ctrl.signal });
        if (!r.ok) throw new Error("unavailable");
        const data = await r.json();
        setState(data);
      } catch {
        setState(null);
      } finally {
        setLoading(false);
      }
    })();
    return () => ctrl.abort();
  }, []);

  return { state, loading };
}
